import { __awaiter, __generator } from "tslib";
import { BackInStockActions } from '../../../../../actions/BackInStockActions/BackInStockActions';
import { getCartIconControllerConfig } from '../../../../wixcode/internalOnlineStoresOnly/getCartIconControllerConfig';
import { WIX_ECOM } from '@wix/app-definition-ids';
export function backInStockActionsFactory(_a) {
    var _b;
    var context = _a.context, origin = _a.origin, _c = _a.requireCompId, requireCompId = _c === void 0 ? false : _c, isOnlineStoresViewerScript = _a.isOnlineStoresViewerScript;
    return __awaiter(this, void 0, void 0, function () {
        var compId, ecomPublicApi, cartIconCompIdAndExternalId;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!isOnlineStoresViewerScript) return [3 /*break*/, 2];
                    return [4 /*yield*/, context.wixAPI.site.getPublicAPI(WIX_ECOM)];
                case 1:
                    ecomPublicApi = _d.sent();
                    cartIconCompIdAndExternalId = ecomPublicApi.__internalOnlineStoresOnly.getCartIconCompIdAndExternalId();
                    compId = cartIconCompIdAndExternalId === null || cartIconCompIdAndExternalId === void 0 ? void 0 : cartIconCompIdAndExternalId.compId;
                    return [3 /*break*/, 3];
                case 2:
                    compId = (_b = getCartIconControllerConfig(context)) === null || _b === void 0 ? void 0 : _b.compId;
                    _d.label = 3;
                case 3:
                    if (requireCompId && !compId) {
                        throw new Error('Cart Icon compId was not acquired');
                    }
                    return [2 /*return*/, new BackInStockActions({
                            siteStore: context.siteStore,
                            origin: origin,
                            compId: compId !== null && compId !== void 0 ? compId : '',
                        })];
            }
        });
    });
}
//# sourceMappingURL=backInStockActionsFactory.js.map